import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { strings } from 'APP_ROOT/localization';

export default class LowBatteryBadge extends React.PureComponent {

    render() {
        return (
            <div className="idling-badge">
                {strings.event_description_car_battery_low}
            </div>
        )
    }
}